export enum DeliveryOrderStatuses {
  Open = 'Offen',
  Canceled = 'Storniert',
  PartlyFinished = 'Teilweise abgeschlossen',
  Finished = 'Abgeschlossen',
}
